import styled from '@emotion/styled';
import { css } from '@emotion/core';

const baseStyles = ({ theme }) => css`
  background-color: ${theme.colors.n500};
  width: 100%;
  height: 1px;
`;

const Divider = styled('div')(baseStyles);

export default Divider;
